export const environment = {
  apiBaseUrl: 'https://dev.api.sbv360.com',
  environment: 'dev',
  NX_APP_AZURE_AD_CLIENT_ID: 'e69aa1c8-a4f5-46e0-b9a0-4e60411ebd25',
  NX_APP_AZURE_AD_AUTHORITY:
    'https://login.microsoftonline.com/de9df500-9b25-4668-8c85-c9cce76cc306/v2.0',
  NX_APP_AZURE_AD_API_SCOPE: 'api://e69aa1c8-a4f5-46e0-b9a0-4e60411ebd25/API',
};
